export default function ({ redirect, route }) {
  if (!route.query.token || !route.query.id) return redirect('/');
}
